import { render, staticRenderFns } from "./ResponsibilityEdit.vue?vue&type=template&id=5b1f20ba&scoped=true&"
import script from "./ResponsibilityEdit.vue?vue&type=script&lang=js&"
export * from "./ResponsibilityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f20ba",
  null
  
)

export default component.exports